import React from "react";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { useCertificationsQuery } from "@common/hooks/useSelectableItemQueries.ts";

export interface LegalEntityCertificationsFieldProps {
    certificationIds: Array<string>;
    onChange: (certificationIds: Array<string>) => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function LegalEntityCertificationsField(props: LegalEntityCertificationsFieldProps) {
    const { translateString } = useTranslation();
    const certificationsQuery = useCertificationsQuery(!props.isPreview);

    return (
        <DotLegalMultiSelect
            options={certificationsQuery.data}
            chosenOptions={props.certificationIds}
            onChange={props.readOnly ? () => {} : props.onChange}
            label={translateString("certifications")}
            noOptionsLabel={translateString("noOptions")}
            isLoading={certificationsQuery.isLoading && !props.readOnly}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default LegalEntityCertificationsField;
